/* istanbul ignore file */
import { Fraction as ActualFraction } from '@codegrade/bigfraction';
import { parsers } from '@codegrade/utils';
const FractionParser = parsers.fraction;
export class Fraction extends ActualFraction {
    static decode(input) {
        return FractionParser.decode(input);
    }
    static unsafeDecode(input) {
        return Fraction.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return FractionParser.encode(data);
    }
    static schema() {
        return FractionParser.schema();
    }
}
